module.exports = __webpack_public_path__ + "img/platform-activities-in-top-few-times-in-row.c83f2d42.png";